// GERADO POR scripts/generate-phone-registry.cjs — NAO EDITAR A MAO
// Regenerar com: node scripts/generate-phone-registry.cjs
import { TCountryEntry } from "./types"

export const CountryRegistry: TCountryEntry[] = [
  { iso: "BR", namePtBr: "Brasil", ddi: "55", order: 0 },
  { iso: "AF", namePtBr: "Afeganistão", ddi: "93", order: 1 },
  { iso: "ZA", namePtBr: "África do Sul", ddi: "27", order: 2 },
  { iso: "AL", namePtBr: "Albânia", ddi: "355", order: 3 },
  { iso: "DE", namePtBr: "Alemanha", ddi: "49", order: 4 },
  { iso: "AD", namePtBr: "Andorra", ddi: "376", order: 5 },
  { iso: "AO", namePtBr: "Angola", ddi: "244", order: 6 },
  { iso: "AI", namePtBr: "Anguila", ddi: "1", order: 7 },
  { iso: "AG", namePtBr: "Antígua e Barbuda", ddi: "1", order: 8 },
  { iso: "SA", namePtBr: "Arábia Saudita", ddi: "966", order: 9 },
  { iso: "DZ", namePtBr: "Argélia", ddi: "213", order: 10 },
  { iso: "AR", namePtBr: "Argentina", ddi: "54", order: 11 },
  { iso: "AM", namePtBr: "Armênia", ddi: "374", order: 12 },
  { iso: "AW", namePtBr: "Aruba", ddi: "297", order: 13 },
  { iso: "AU", namePtBr: "Austrália", ddi: "61", order: 14 },
  { iso: "AT", namePtBr: "Áustria", ddi: "43", order: 15 },
  { iso: "AZ", namePtBr: "Azerbaijão", ddi: "994", order: 16 },
  { iso: "BS", namePtBr: "Bahamas", ddi: "1", order: 17 },
  { iso: "BD", namePtBr: "Bangladesh", ddi: "880", order: 18 },
  { iso: "BB", namePtBr: "Barbados", ddi: "1", order: 19 },
  { iso: "BH", namePtBr: "Barein", ddi: "973", order: 20 },
  { iso: "BE", namePtBr: "Bélgica", ddi: "32", order: 21 },
  { iso: "BZ", namePtBr: "Belize", ddi: "501", order: 22 },
  { iso: "BJ", namePtBr: "Benin", ddi: "229", order: 23 },
  { iso: "BM", namePtBr: "Bermudas", ddi: "1", order: 24 },
  { iso: "BY", namePtBr: "Bielorrússia", ddi: "375", order: 25 },
  { iso: "BO", namePtBr: "Bolívia", ddi: "591", order: 26 },
  { iso: "BA", namePtBr: "Bósnia e Herzegovina", ddi: "387", order: 27 },
  { iso: "BW", namePtBr: "Botsuana", ddi: "267", order: 28 },
  { iso: "BN", namePtBr: "Brunei", ddi: "673", order: 29 },
  { iso: "BG", namePtBr: "Bulgária", ddi: "359", order: 30 },
  { iso: "BF", namePtBr: "Burquina Faso", ddi: "226", order: 31 },
  { iso: "BI", namePtBr: "Burundi", ddi: "257", order: 32 },
  { iso: "BT", namePtBr: "Butão", ddi: "975", order: 33 },
  { iso: "CV", namePtBr: "Cabo Verde", ddi: "238", order: 34 },
  { iso: "CM", namePtBr: "Camarões", ddi: "237", order: 35 },
  { iso: "KH", namePtBr: "Camboja", ddi: "855", order: 36 },
  { iso: "CA", namePtBr: "Canadá", ddi: "1", order: 37 },
  { iso: "QA", namePtBr: "Catar", ddi: "974", order: 38 },
  { iso: "KZ", namePtBr: "Cazaquistão", ddi: "7", order: 39 },
  { iso: "TD", namePtBr: "Chade", ddi: "235", order: 40 },
  { iso: "CL", namePtBr: "Chile", ddi: "56", order: 41 },
  { iso: "CN", namePtBr: "China", ddi: "86", order: 42 },
  { iso: "CY", namePtBr: "Chipre", ddi: "357", order: 43 },
  { iso: "VA", namePtBr: "Cidade do Vaticano", ddi: "39", order: 44 },
  { iso: "CO", namePtBr: "Colômbia", ddi: "57", order: 45 },
  { iso: "KM", namePtBr: "Comores", ddi: "269", order: 46 },
  { iso: "CD", namePtBr: "Congo - Kinshasa", ddi: "243", order: 47 },
  { iso: "KP", namePtBr: "Coreia do Norte", ddi: "850", order: 48 },
  { iso: "KR", namePtBr: "Coreia do Sul", ddi: "82", order: 49 },
  { iso: "CI", namePtBr: "Costa do Marfim", ddi: "225", order: 50 },
  { iso: "CR", namePtBr: "Costa Rica", ddi: "506", order: 51 },
  { iso: "HR", namePtBr: "Croácia", ddi: "385", order: 52 },
  { iso: "CU", namePtBr: "Cuba", ddi: "53", order: 53 },
  { iso: "CW", namePtBr: "Curaçao", ddi: "599", order: 54 },
  { iso: "DK", namePtBr: "Dinamarca", ddi: "45", order: 55 },
  { iso: "DJ", namePtBr: "Djibuti", ddi: "253", order: 56 },
  { iso: "DM", namePtBr: "Dominica", ddi: "1", order: 57 },
  { iso: "EG", namePtBr: "Egito", ddi: "20", order: 58 },
  { iso: "SV", namePtBr: "El Salvador", ddi: "503", order: 59 },
  { iso: "AE", namePtBr: "Emirados Árabes Unidos", ddi: "971", order: 60 },
  { iso: "EC", namePtBr: "Equador", ddi: "593", order: 61 },
  { iso: "ER", namePtBr: "Eritreia", ddi: "291", order: 62 },
  { iso: "SK", namePtBr: "Eslováquia", ddi: "421", order: 63 },
  { iso: "SI", namePtBr: "Eslovênia", ddi: "386", order: 64 },
  { iso: "ES", namePtBr: "Espanha", ddi: "34", order: 65 },
  { iso: "SZ", namePtBr: "Essuatíni", ddi: "268", order: 66 },
  { iso: "US", namePtBr: "Estados Unidos", ddi: "1", order: 67 },
  { iso: "EE", namePtBr: "Estônia", ddi: "372", order: 68 },
  { iso: "ET", namePtBr: "Etiópia", ddi: "251", order: 69 },
  { iso: "FJ", namePtBr: "Fiji", ddi: "679", order: 70 },
  { iso: "PH", namePtBr: "Filipinas", ddi: "63", order: 71 },
  { iso: "FI", namePtBr: "Finlândia", ddi: "358", order: 72 },
  { iso: "FR", namePtBr: "França", ddi: "33", order: 73 },
  { iso: "GA", namePtBr: "Gabão", ddi: "241", order: 74 },
  { iso: "GM", namePtBr: "Gâmbia", ddi: "220", order: 75 },
  { iso: "GH", namePtBr: "Gana", ddi: "233", order: 76 },
  { iso: "GE", namePtBr: "Geórgia", ddi: "995", order: 77 },
  { iso: "GI", namePtBr: "Gibraltar", ddi: "350", order: 78 },
  { iso: "GD", namePtBr: "Granada", ddi: "1", order: 79 },
  { iso: "GR", namePtBr: "Grécia", ddi: "30", order: 80 },
  { iso: "GL", namePtBr: "Groenlândia", ddi: "299", order: 81 },
  { iso: "GP", namePtBr: "Guadalupe", ddi: "590", order: 82 },
  { iso: "GU", namePtBr: "Guam", ddi: "1", order: 83 },
  { iso: "GT", namePtBr: "Guatemala", ddi: "502", order: 84 },
  { iso: "GG", namePtBr: "Guernsey", ddi: "44", order: 85 },
  { iso: "GY", namePtBr: "Guiana", ddi: "592", order: 86 },
  { iso: "GF", namePtBr: "Guiana Francesa", ddi: "594", order: 87 },
  { iso: "GN", namePtBr: "Guiné", ddi: "224", order: 88 },
  { iso: "GQ", namePtBr: "Guiné Equatorial", ddi: "240", order: 89 },
  { iso: "GW", namePtBr: "Guiné-Bissau", ddi: "245", order: 90 },
  { iso: "HT", namePtBr: "Haiti", ddi: "509", order: 91 },
  { iso: "HN", namePtBr: "Honduras", ddi: "504", order: 92 },
  { iso: "HK", namePtBr: "Hong Kong, RAE da China", ddi: "852", order: 93 },
  { iso: "HU", namePtBr: "Hungria", ddi: "36", order: 94 },
  { iso: "YE", namePtBr: "Iêmen", ddi: "967", order: 95 },
  { iso: "CX", namePtBr: "Ilha Christmas", ddi: "61", order: 96 },
  { iso: "AC", namePtBr: "Ilha de Ascensão", ddi: "247", order: 97 },
  { iso: "IM", namePtBr: "Ilha de Man", ddi: "44", order: 98 },
  { iso: "NF", namePtBr: "Ilha Norfolk", ddi: "672", order: 99 },
  { iso: "AX", namePtBr: "Ilhas Aland", ddi: "358", order: 100 },
  { iso: "KY", namePtBr: "Ilhas Cayman", ddi: "1", order: 101 },
  { iso: "CC", namePtBr: "Ilhas Cocos (Keeling)", ddi: "61", order: 102 },
  { iso: "CK", namePtBr: "Ilhas Cook", ddi: "682", order: 103 },
  { iso: "FO", namePtBr: "Ilhas Faroé", ddi: "298", order: 104 },
  { iso: "FK", namePtBr: "Ilhas Malvinas", ddi: "500", order: 105 },
  { iso: "MP", namePtBr: "Ilhas Marianas do Norte", ddi: "1", order: 106 },
  { iso: "MH", namePtBr: "Ilhas Marshall", ddi: "692", order: 107 },
  { iso: "SB", namePtBr: "Ilhas Salomão", ddi: "677", order: 108 },
  { iso: "TC", namePtBr: "Ilhas Turcas e Caicos", ddi: "1", order: 109 },
  { iso: "VI", namePtBr: "Ilhas Virgens Americanas", ddi: "1", order: 110 },
  { iso: "VG", namePtBr: "Ilhas Virgens Britânicas", ddi: "1", order: 111 },
  { iso: "IN", namePtBr: "Índia", ddi: "91", order: 112 },
  { iso: "ID", namePtBr: "Indonésia", ddi: "62", order: 113 },
  { iso: "IR", namePtBr: "Irã", ddi: "98", order: 114 },
  { iso: "IQ", namePtBr: "Iraque", ddi: "964", order: 115 },
  { iso: "IE", namePtBr: "Irlanda", ddi: "353", order: 116 },
  { iso: "IS", namePtBr: "Islândia", ddi: "354", order: 117 },
  { iso: "IL", namePtBr: "Israel", ddi: "972", order: 118 },
  { iso: "IT", namePtBr: "Itália", ddi: "39", order: 119 },
  { iso: "JM", namePtBr: "Jamaica", ddi: "1", order: 120 },
  { iso: "JP", namePtBr: "Japão", ddi: "81", order: 121 },
  { iso: "JE", namePtBr: "Jersey", ddi: "44", order: 122 },
  { iso: "JO", namePtBr: "Jordânia", ddi: "962", order: 123 },
  { iso: "XK", namePtBr: "Kosovo", ddi: "383", order: 124 },
  { iso: "KW", namePtBr: "Kuwait", ddi: "965", order: 125 },
  { iso: "LA", namePtBr: "Laos", ddi: "856", order: 126 },
  { iso: "LS", namePtBr: "Lesoto", ddi: "266", order: 127 },
  { iso: "LV", namePtBr: "Letônia", ddi: "371", order: 128 },
  { iso: "LB", namePtBr: "Líbano", ddi: "961", order: 129 },
  { iso: "LR", namePtBr: "Libéria", ddi: "231", order: 130 },
  { iso: "LY", namePtBr: "Líbia", ddi: "218", order: 131 },
  { iso: "LI", namePtBr: "Liechtenstein", ddi: "423", order: 132 },
  { iso: "LT", namePtBr: "Lituânia", ddi: "370", order: 133 },
  { iso: "LU", namePtBr: "Luxemburgo", ddi: "352", order: 134 },
  { iso: "MO", namePtBr: "Macau, RAE da China", ddi: "853", order: 135 },
  { iso: "MK", namePtBr: "Macedônia do Norte", ddi: "389", order: 136 },
  { iso: "MG", namePtBr: "Madagascar", ddi: "261", order: 137 },
  { iso: "MY", namePtBr: "Malásia", ddi: "60", order: 138 },
  { iso: "MW", namePtBr: "Malaui", ddi: "265", order: 139 },
  { iso: "MV", namePtBr: "Maldivas", ddi: "960", order: 140 },
  { iso: "ML", namePtBr: "Mali", ddi: "223", order: 141 },
  { iso: "MT", namePtBr: "Malta", ddi: "356", order: 142 },
  { iso: "MA", namePtBr: "Marrocos", ddi: "212", order: 143 },
  { iso: "MQ", namePtBr: "Martinica", ddi: "596", order: 144 },
  { iso: "MU", namePtBr: "Maurício", ddi: "230", order: 145 },
  { iso: "MR", namePtBr: "Mauritânia", ddi: "222", order: 146 },
  { iso: "YT", namePtBr: "Mayotte", ddi: "262", order: 147 },
  { iso: "MX", namePtBr: "México", ddi: "52", order: 148 },
  { iso: "MM", namePtBr: "Mianmar (Birmânia)", ddi: "95", order: 149 },
  { iso: "FM", namePtBr: "Micronésia", ddi: "691", order: 150 },
  { iso: "MZ", namePtBr: "Moçambique", ddi: "258", order: 151 },
  { iso: "MD", namePtBr: "Moldávia", ddi: "373", order: 152 },
  { iso: "MC", namePtBr: "Mônaco", ddi: "377", order: 153 },
  { iso: "MN", namePtBr: "Mongólia", ddi: "976", order: 154 },
  { iso: "ME", namePtBr: "Montenegro", ddi: "382", order: 155 },
  { iso: "MS", namePtBr: "Montserrat", ddi: "1", order: 156 },
  { iso: "NA", namePtBr: "Namíbia", ddi: "264", order: 157 },
  { iso: "NR", namePtBr: "Nauru", ddi: "674", order: 158 },
  { iso: "NP", namePtBr: "Nepal", ddi: "977", order: 159 },
  { iso: "NI", namePtBr: "Nicarágua", ddi: "505", order: 160 },
  { iso: "NE", namePtBr: "Níger", ddi: "227", order: 161 },
  { iso: "NG", namePtBr: "Nigéria", ddi: "234", order: 162 },
  { iso: "NU", namePtBr: "Niue", ddi: "683", order: 163 },
  { iso: "NO", namePtBr: "Noruega", ddi: "47", order: 164 },
  { iso: "NC", namePtBr: "Nova Caledônia", ddi: "687", order: 165 },
  { iso: "NZ", namePtBr: "Nova Zelândia", ddi: "64", order: 166 },
  { iso: "OM", namePtBr: "Omã", ddi: "968", order: 167 },
  { iso: "NL", namePtBr: "Países Baixos", ddi: "31", order: 168 },
  { iso: "BQ", namePtBr: "Países Baixos Caribenhos", ddi: "599", order: 169 },
  { iso: "PW", namePtBr: "Palau", ddi: "680", order: 170 },
  { iso: "PA", namePtBr: "Panamá", ddi: "507", order: 171 },
  { iso: "PG", namePtBr: "Papua-Nova Guiné", ddi: "675", order: 172 },
  { iso: "PK", namePtBr: "Paquistão", ddi: "92", order: 173 },
  { iso: "PY", namePtBr: "Paraguai", ddi: "595", order: 174 },
  { iso: "PE", namePtBr: "Peru", ddi: "51", order: 175 },
  { iso: "PF", namePtBr: "Polinésia Francesa", ddi: "689", order: 176 },
  { iso: "PL", namePtBr: "Polônia", ddi: "48", order: 177 },
  { iso: "PR", namePtBr: "Porto Rico", ddi: "1", order: 178 },
  { iso: "PT", namePtBr: "Portugal", ddi: "351", order: 179 },
  { iso: "KE", namePtBr: "Quênia", ddi: "254", order: 180 },
  { iso: "KG", namePtBr: "Quirguistão", ddi: "996", order: 181 },
  { iso: "KI", namePtBr: "Quiribati", ddi: "686", order: 182 },
  { iso: "GB", namePtBr: "Reino Unido", ddi: "44", order: 183 },
  { iso: "CF", namePtBr: "República Centro-Africana", ddi: "236", order: 184 },
  { iso: "CG", namePtBr: "República do Congo", ddi: "242", order: 185 },
  { iso: "DO", namePtBr: "República Dominicana", ddi: "1", order: 186 },
  { iso: "RE", namePtBr: "Reunião", ddi: "262", order: 187 },
  { iso: "RO", namePtBr: "Romênia", ddi: "40", order: 188 },
  { iso: "RW", namePtBr: "Ruanda", ddi: "250", order: 189 },
  { iso: "RU", namePtBr: "Rússia", ddi: "7", order: 190 },
  { iso: "EH", namePtBr: "Saara Ocidental", ddi: "212", order: 191 },
  { iso: "WS", namePtBr: "Samoa", ddi: "685", order: 192 },
  { iso: "AS", namePtBr: "Samoa Americana", ddi: "1", order: 193 },
  { iso: "SM", namePtBr: "San Marino", ddi: "378", order: 194 },
  { iso: "SH", namePtBr: "Santa Helena", ddi: "290", order: 195 },
  { iso: "LC", namePtBr: "Santa Lúcia", ddi: "1", order: 196 },
  { iso: "BL", namePtBr: "São Bartolomeu", ddi: "590", order: 197 },
  { iso: "KN", namePtBr: "São Cristóvão e Névis", ddi: "1", order: 198 },
  { iso: "MF", namePtBr: "São Martinho", ddi: "590", order: 199 },
  { iso: "PM", namePtBr: "São Pedro e Miquelão", ddi: "508", order: 200 },
  { iso: "ST", namePtBr: "São Tomé e Príncipe", ddi: "239", order: 201 },
  { iso: "VC", namePtBr: "São Vicente e Granadinas", ddi: "1", order: 202 },
  { iso: "SC", namePtBr: "Seicheles", ddi: "248", order: 203 },
  { iso: "SN", namePtBr: "Senegal", ddi: "221", order: 204 },
  { iso: "SL", namePtBr: "Serra Leoa", ddi: "232", order: 205 },
  { iso: "RS", namePtBr: "Sérvia", ddi: "381", order: 206 },
  { iso: "SG", namePtBr: "Singapura", ddi: "65", order: 207 },
  { iso: "SX", namePtBr: "Sint Maarten", ddi: "1", order: 208 },
  { iso: "SY", namePtBr: "Síria", ddi: "963", order: 209 },
  { iso: "SO", namePtBr: "Somália", ddi: "252", order: 210 },
  { iso: "LK", namePtBr: "Sri Lanka", ddi: "94", order: 211 },
  { iso: "SD", namePtBr: "Sudão", ddi: "249", order: 212 },
  { iso: "SS", namePtBr: "Sudão do Sul", ddi: "211", order: 213 },
  { iso: "SE", namePtBr: "Suécia", ddi: "46", order: 214 },
  { iso: "CH", namePtBr: "Suíça", ddi: "41", order: 215 },
  { iso: "SR", namePtBr: "Suriname", ddi: "597", order: 216 },
  { iso: "SJ", namePtBr: "Svalbard e Jan Mayen", ddi: "47", order: 217 },
  { iso: "TJ", namePtBr: "Tadjiquistão", ddi: "992", order: 218 },
  { iso: "TH", namePtBr: "Tailândia", ddi: "66", order: 219 },
  { iso: "TW", namePtBr: "Taiwan", ddi: "886", order: 220 },
  { iso: "TZ", namePtBr: "Tanzânia", ddi: "255", order: 221 },
  { iso: "CZ", namePtBr: "Tchéquia", ddi: "420", order: 222 },
  { iso: "IO", namePtBr: "Território Britânico do Oceano Índico", ddi: "246", order: 223 },
  { iso: "PS", namePtBr: "Territórios palestinos", ddi: "970", order: 224 },
  { iso: "TL", namePtBr: "Timor-Leste", ddi: "670", order: 225 },
  { iso: "TG", namePtBr: "Togo", ddi: "228", order: 226 },
  { iso: "TK", namePtBr: "Tokelau", ddi: "690", order: 227 },
  { iso: "TO", namePtBr: "Tonga", ddi: "676", order: 228 },
  { iso: "TT", namePtBr: "Trinidad e Tobago", ddi: "1", order: 229 },
  { iso: "TA", namePtBr: "Tristão da Cunha", ddi: "290", order: 230 },
  { iso: "TN", namePtBr: "Tunísia", ddi: "216", order: 231 },
  { iso: "TM", namePtBr: "Turcomenistão", ddi: "993", order: 232 },
  { iso: "TR", namePtBr: "Turquia", ddi: "90", order: 233 },
  { iso: "TV", namePtBr: "Tuvalu", ddi: "688", order: 234 },
  { iso: "UA", namePtBr: "Ucrânia", ddi: "380", order: 235 },
  { iso: "UG", namePtBr: "Uganda", ddi: "256", order: 236 },
  { iso: "UY", namePtBr: "Uruguai", ddi: "598", order: 237 },
  { iso: "UZ", namePtBr: "Uzbequistão", ddi: "998", order: 238 },
  { iso: "VU", namePtBr: "Vanuatu", ddi: "678", order: 239 },
  { iso: "VE", namePtBr: "Venezuela", ddi: "58", order: 240 },
  { iso: "VN", namePtBr: "Vietnã", ddi: "84", order: 241 },
  { iso: "WF", namePtBr: "Wallis e Futuna", ddi: "681", order: 242 },
  { iso: "ZM", namePtBr: "Zâmbia", ddi: "260", order: 243 },
  { iso: "ZW", namePtBr: "Zimbábue", ddi: "263", order: 244 },
]
